import { css } from 'styled-components';
import { colors } from './colors';

export const tables = css`
  table {
    font-size: 1.8rem;
    text-align: left;
    border: 1px solid ${colors.gray};
    border-radius: 2px;

    th,
    td {
      padding: 5px 10px;
    }

    tr {
      &:nth-child(2n + 1) {
        background: ${colors.white};
      }

      &:nth-child(2n) {
        background: ${colors.grayLight};
      }
    }

    thead {
      th {
        background: ${colors.secondary};
        color: ${colors.white};
        font-weight: 500;
      }
    }
  }

  .content-table {
    overflow-x: auto;
  }
`;
